import { modules } from "@/components/dataset-modules";
import { DateTime } from "luxon";
import CellStatus from "./cell/status-cell";
import { db } from "@/module/firebase";
import store from "@/store";

export default {
  source_type: "FILE",
  source: [],
  paginate: {
    //limit: 10,
    sort: {
      field: "name",
      order: "ASC"
    }
  },



  column_order: ['name','street','city','state','zipcode','phone','email','followup','clientTypeValue','clientContractValue','clientStatusValue','budget','salePrice','commission','flatFeeCommission','coBrokeIsSelected','coBroke','grossCommission','referral','split','projectedCommission','actualCommission','expenses','taxProjection','hoursSpent','listingDate','contractDate','closingDate','listingId','source','neighborhood','propertyType','daysOnMarket','companyPayment','referralPayment','note'],
  visibility: ['name','street','city','state','zipcode','phone','email','followup','clientTypeValue','clientContractValue','clientStatusValue','budget','salePrice','commission','flatFeeCommission','coBrokeIsSelected','coBroke','grossCommission','referral','split','projectedCommission','actualCommission','expenses','taxProjection','hoursSpent','listingDate','contractDate','closingDate','listingId','source','neighborhood','propertyType','daysOnMarket','companyPayment','referralPayment','note'],

  sorting: ['name','street','city','state','zipcode','phone','email','followup','clientTypeValue','clientContractValue','clientStatusValue','budget','commission','commissionToSort','flatFeeCommission','coBrokeIsSelected','coBroke','grossCommission','referral','split','projectedCommission','actualCommission','expenses','taxProjection','hoursSpent','listingDate','contractDate','closingDate','listingId','source','neighborhood','propertyType','daysOnMarket','companyPayment','referralPayment','note'],


  column_map: {
  //  check: {
  //     label: "Choose",
  //     format: "CHECKBOX"
  //   },
  expenses:{
    label:'Expenses',
    format:modules.money
  },
  actualCommission:{
    label:'Net Commission',
    format:modules.money,
  },
  coBroke:{
    label:'Co-Broke %',
    format:modules.percent,
  },
  commission:{
    label:'Commission %',
    format:modules.percent,

  },
  followup:{
    label:'Follow Up',
    format:modules.dateFormat,
    narrow: true,

  },
  lastUpdate: {
    label: "Last Update",
    format: modules.dateFormat,
    narrow: true,
  },
    name: {
      label: "Name",
      format: "TEXT"
    },
    
    email: {
      label: "Email",
      format: "TEXT",
      
    },
    phone: {
      label: "Phone",
      format: "TEXT",
      narrow: true
    },
    city: {
      label: "City",
      format: "TEXT",
      narrow: true  
    },

    state: {
      label: "State",
      format: "TEXT"
    },
    street: {
      label: "Street",
      format: "TEXT"
    },
    zipcode: {
      label: "Zip Code",
      format: "TEXT"
    },
    budget: {
      label: "Budget/1st Ask",
      format: modules.money,
      narrow: true
    },
    clientContractValue: {
      label: "Status",
      format: "TEXT"
    },
    clientStatusValue: {
      label: "Urgency",
      format: "TEXT"
    },
    clientTypeValue: {
      label: "Client Type",
      format: "TEXT"
    },
    coBrokeIsSelected: {
      label: "Co-Broke ?",
      format: modules.boolIcon,
      narrow: true
    },
    commissionToSort: {
      label: "Commission #",
      format: modules.money,

    },
    companyPayment: {
      label: "Company Payment",
      format: modules.money,
      narrow: true
    },
    
   
    daysOnMarket: {
      label: "Days On Market",
      format: modules.digit,
      narrow: true
    },
    flatFeeCommission: {
      label: "Flat Fee Commission",
      format: modules.money

    },
    grossCommission: {
      label: "Gross Commission",
      format: modules.money

    },
    hoursSpent: {
      label: "Hours Spent",
      format: modules.digit,
    },
    isNotificationEnabled: {
      label: "Notification Enabled",
      format: modules.boolIcon,
      narrow: true
    },

    projectedCommission: {
      label: "Projected Commission",
      format: modules.money

    },
    propertyType: {
      label: "Property Type",
      format: "TEXT"
    },
    referral: {
      label: "Referral",
      format: modules.percent,
      narrow: true
    },
    referralPayment: {
      label: "Referral Payment",
      format: modules.money,
      narrow: true
    },
    
    split: {
      label: "Split",
      format: modules.percent,
    },
    actualCommission: {
      label: "Net Commission",
      format: modules.money
    },
    taxProjection: {
      label: "Tax Projection",
      format: modules.money
    },
    listingDate: {
      label: "Listing Date",
      format: modules.dateFormat,
      // narrow: true,
    },
    neighborhood: {
      label: "Neighborhood",
      format: "TEXT"
    },
    note: {
      label: "Notes",
      format: "TEXT"
    },
    source: {
      label: "Lead Source",
      format: "TEXT"
    },
    salePrice: {
      label: "Sale Price",
      format: modules.money,
      narrow: true

    },
    contractDate: {
      label: "Contract Date",
      format: modules.dateFormat,
      narrow: true,
    },

    listingId: {
      label: "Listing ID",
      format: "TEXT"
    },
    closingDate: {
      label: "Closing Date",
      format: modules.dateFormat,
      narrow: true,
    },
  }
};
